import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Gauge, ArrowRight } from "lucide-react";

export default function Login() {
  const { login, error } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) navigate("/app");
  };

  return (
    <div className="bg-noise min-h-screen grid grid-cols-1 lg:grid-cols-2" style={{ background: "var(--avsl-bg)" }}>
      {/* Left - visual */}
      <div className="relative hidden lg:block overflow-hidden" style={{ background: "#050505" }}>
        <img
          src="https://images.pexels.com/photos/24589327/pexels-photo-24589327.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, rgba(0,0,0,0.2) 0%, rgba(10,10,10,0.9) 100%)" }} />
        <div className="absolute top-8 left-8 flex items-center gap-3 z-10">
          <div className="w-10 h-10 flex items-center justify-center" style={{ background: "var(--avsl-red)" }}>
            <Gauge size={22} strokeWidth={2.5} color="#fff" />
          </div>
          <div>
            <div className="font-display text-2xl leading-none">AVSL</div>
            <div className="overline mt-1">Rastreamento Veicular</div>
          </div>
        </div>
        <div className="absolute bottom-10 left-8 right-8 z-10">
          <div className="overline mb-3" style={{ color: "var(--avsl-red-soft)" }}>Ad Studio · Gerador de Anúncios</div>
          <h1 className="font-display text-6xl leading-[0.9]">
            Anúncios que <br /> <span style={{ color: "var(--avsl-red)" }}>convertem em segundos.</span>
          </h1>
          <p className="mt-6 text-neutral-400 max-w-md">
            Gere copy e imagens prontas para Instagram com a identidade AVSL. Direto ao ponto.
          </p>
        </div>
        <div className="absolute top-0 right-0 h-full w-4 stripe-red opacity-40" />
      </div>

      {/* Right - form */}
      <div className="flex items-center justify-center px-6 py-16 relative z-10">
        <div className="w-full max-w-md">
          <div className="overline mb-3">Acesso Restrito</div>
          <h2 className="font-display text-5xl leading-none">Entrar</h2>
          <p className="mt-3 text-neutral-400 text-sm">Use seu e-mail cadastrado.</p>

          <form onSubmit={submit} className="mt-10 space-y-5" data-testid="login-form">
            <div>
              <label className="overline mb-2 block">E-mail</label>
              <input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="avsl-input"
                placeholder="voce@empresa.com"
              />
            </div>
            <div>
              <label className="overline mb-2 block">Senha</label>
              <input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="avsl-input"
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div data-testid="login-error" className="border-l-2 pl-3 py-2 text-sm text-red-300" style={{ borderColor: "var(--avsl-red)" }}>
                {error}
              </div>
            )}

            <button data-testid="login-submit" type="submit" disabled={loading} className="avsl-btn w-full">
              {loading ? "Entrando..." : (<>Entrar <ArrowRight size={16} strokeWidth={2.5} className="ml-2" /></>)}
            </button>
          </form>

          <div className="mt-8 text-sm text-neutral-500">
            Não tem conta?{" "}
            <Link to="/register" data-testid="link-register" className="text-white hover:text-red-400 underline underline-offset-4">
              Cadastre-se
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
